import React, { useCallback, useContext, useReducer } from "react";
import { Commands } from 'shared/resources/BitbiteCommands';
import { SessionContext } from 'shared/system-controls/session/SessionProvider';
import AccountListReducer from 'accounts/list/state/AccountListReducer';

export const AccountListContext = React.createContext();

const AccountListState = ({ children }) => {
	const initialState = {
		filters: {},
		accountSearchFilters: [],
		count: 50,
	}
	const [state, dispatch] = useReducer(AccountListReducer, initialState);
	const { asyncServiceCall, sessionData, setSessionData } = useContext(SessionContext);

	//----------------------------------
	const search = useCallback(async ({ filters, pageNo, count, accountSearchFilters, download }) => {
		try {
			dispatch({ type: 'IN_LOADING' });
			filters = filters || {};
			filters = Object.keys(filters).reduce((t, k) => filters[k] ? { ...t, [k]: filters[k] } : t, {});
			accountSearchFilters = accountSearchFilters || [];

			if (Object.keys(filters).length > 0 && JSON.stringify(accountSearchFilters[0] || {}) !== JSON.stringify(filters)) {
				accountSearchFilters = [filters].concat(accountSearchFilters).slice(0, 5);
				setSessionData({ accountSearchFilters: accountSearchFilters });
			}
			count = count || 25;

			let _filters = filters || {};
			if (filters.area) {
				_filters.areaID = _filters.area.areaID;
				delete _filters.area;
			}
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_SUPPORT_ACCOUNTS, {
				..._filters,
				first: (pageNo >= 0 ? pageNo : 0) * count,
				count: count,
				download: download ? 1 : 0,
			});

			if (download) {
				dispatch({ type: 'LOADED' });
				let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + res;
				var encodedUri = encodeURI(csvContent);

				var link = document.createElement("a");
				link.setAttribute("href", encodedUri);
				link.setAttribute("download", "users.csv");
				document.body.appendChild(link);
				link.click();
				return;
			}

			if (!(pageNo >= 0)) {
				setTimeout(async () => {
					let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_SUPPORT_ACCOUNTS, {
						..._filters,
						first: (pageNo >= 0 ? pageNo : 0) * count,
						countOnly: 1,
					});
					dispatch({ type: 'SET_STATE_DATA', payload: { total: res.total } });
				}, 10);
			}

			// res.users = new Array(25).fill({});
			// res.total = 120;
			dispatch({
				type: 'SET_STATE_DATA', payload: {
					...res,
					first: (pageNo >= 0 ? pageNo : 0) * count,
					count: count,
				}
			});
			dispatch({ type: 'LOADED' });
		}
		catch (err) {
			console.log(err);
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall, setSessionData]);


	//----------------------------------
	const serviceSearch = useCallback(async ({ filters, pageNo, count, }) => {
		try {
			dispatch({ type: 'IN_LOADING' });
			filters = filters || {};
			count = count || 25;

			let _filters = filters || {};
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_SUPPORT_FILING_SERVICES_SEARCH, {
				..._filters,
				first: (pageNo >= 0 ? pageNo : 0) * count,
				count,
			});
			if (!(pageNo >= 0)) {
				setTimeout(async () => {
					let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_SUPPORT_FILING_SERVICES_SEARCH, {
						..._filters,
						first: (pageNo >= 0 ? pageNo : 0) * count,
						countOnly: 1,
					});
					dispatch({ type: 'SET_STATE_DATA', payload: { total: res.total } });
				}, 10);
			}

			// res.users = new Array(25).fill({});
			// res.total = 120;
			dispatch({
				type: 'SET_STATE_DATA', payload: {
					services: res,
					first: (pageNo >= 0 ? pageNo : 0) * count,
					count: count,
				}
			});
			dispatch({ type: 'LOADED' });
		}
		catch (err) {
			console.log(err);
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall]);

	//----------------------------------
	const exportFilingServices = useCallback(async ({ fromDate, toDate }) => {
		try {
			console.log(fromDate, toDate);
			dispatch({ type: 'IN_LOADING' });
			let res = await asyncServiceCall(Commands.API_URL_BITBITE_BO_SUPPORT_FILING_SERVICES_EXPORT, { fromDate, toDate }, true);
			const blob = res;
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = 'services.csv';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			URL.revokeObjectURL(url);
			dispatch({ type: 'LOADED' });
		}
		catch (err) {
			console.log(err);
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall]);

	//---------------------------------------------------------------------------
	const clearCounters = useCallback(async ({ userID }) => {
		try {
			if (!userID) {
				return dispatch({ type: 'SET_STATE_DATA', payload: { requireCheck: true } });
			}
			dispatch({ type: 'LOADING' });
			await asyncServiceCall(Commands.API_URL_BITBITE_BO_CLEAR_COUNTERS(userID));
			dispatch({ type: 'SUCCESS', payload: Object.assign({}, { text: 'عملیات با موفقیت انجام شد.', type: 'success' }) });
			dispatch({ type: 'LOADED' });
		}
		catch (err) {
			dispatch({ type: 'LOAD_FAILED', payload: Object.assign({}, { text: err.response?.data?.message || (err + ""), type: 'danger' }) });
		}
	}, [asyncServiceCall])


	return (
		<AccountListContext.Provider
			value={{
				...state,
				state,
				accountSearchFilters: sessionData?.accountSearchFilters,
				dispatch,
				search,
				serviceSearch,
				clearCounters,
				exportFilingServices,
			}}
		>
			{children}
		</AccountListContext.Provider>
	)
}

export default AccountListState
